import { useFormik } from "formik";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { approveCustomer } from "../../../redux/slice/customer/customerSlice";
import * as Yup from "yup";

const ApproveCustomer = ({id}) => {

    const closeRef = useRef();
    const dispatch = useDispatch()

    const onSubmit = (values) => {
      const payload = { ...values, id}
      dispatch(approveCustomer(payload))
      closeRef.current.click()
    }

    const validationScehma = Yup.object().shape({
      status_date: Yup.string("").required(
        "Date cannot be blank"
      ),
    });

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
  useFormik({
    enableReinitialize: true,
    initialValues: {
      status_date: '',
    },
    validationSchema: validationScehma,
    onSubmit,
  });


  return (
    <div className='container'>
    <div className='my-3 text-center'>
      <h3 className='text-dark fs-4'>Approve Customer</h3>
      <p className='lh-sm fs-6'>
        Are you sure you want to approve this customer
      </p>
    </div>
    <div className="row mb-3">
        <div className='col-sm-12'>
            <label for="status_date" className="col-form-label">
              Date of Approval
            </label>
        </div>
        <div class="col-sm-12">
            <input type="date" name='status_date' className="form-control form-control-sm" id="status_date" value={values?.status_date} onChange={handleChange} onBlur={handleBlur}/>
            {errors?.status_date && touched?.status_date && (
                <p className='mb-0 text-danger'>
                    {errors?.status_date + '*'}
                </p>
            )}
        </div>
      </div>
    <div className='d-flex justify-content-between'>
          <div className='d-grid'>
            <button
              ref={closeRef}
              className='btn btn-sm mt-2 px-3 text-muted'
              data-bs-dismiss='modal'
              style={{ background: "#F1F0F1" }}
            >
              Cancel
            </button>
          </div>
          <div className='d-grid'>
            <button
              onClick={handleSubmit}
              className='btn btn-success btn-sm mt-2 px-3 text-white'
            >
              Approve
            </button>
          </div>
        </div>
  </div>
  )
}

export default ApproveCustomer